<div class="feature-section event_list">
  <div class="row">
    <div [ngClass]="sportId ? 'col-6 col-sm-4 col-lg-3' : 'col-6 col-sm-4 col-lg-4'" *ngFor="let eventDetails of eventList">
      <div class="explore-card">
        <div class="profile-header__tags">
          <span
            *ngIf="eventDetails.eventSports.length > 1"
            class="plusCount ml-2 handPointer profile-header__tag"
            placement="bottom"
            ngbTooltip="{{ tooltopAray(eventDetails.eventSports) }}"
            tooltipClass="customtooltip"
            container="body"
          >
            +{{ eventDetails.eventSports?.length - 1 }}
          </span>
          <span
            class="profile-header__tag"
            *ngFor="let sports of eventDetails.eventSports ? eventDetails.eventSports.slice(0, 1) : eventDetails.eventSports"
            (click)="$event.stopPropagation()"
            [routerLink]="userInfo?.id ? '/sports/' + sports?.sportId : ''"
          >
            {{ sports?.sport?.name | titlecase }}
          </span>
        </div>
        <img
          class="exp-img"
          [src]="eventDetails?.largeImage ? fileDirectoriesPath + eventDetails?.largeImage : 'assets/images/ic_level.svg'"
          alt="level icon"
          [ngClass]="eventDetails?.largeImage ? 'banner-img-cover' : ''"
          (click)="vieweventDetails(eventDetails)"
        />
        <figcaption class="event_info">
          <h2 class="ellipsis-title">{{ eventDetails.title || '-' }}</h2>
          <ul>
            <li>
              <div class="eventIcon" [innerHTML]="ICONS.calendarIcon | safeHtml"></div>
              <span>{{ eventDetails?.dateTime | date: DATE_TIME_FORMAT }} to {{ eventDetails?.endDateTime | date: DATE_TIME_FORMAT }}</span>
            </li>
            <li>
              <div class="eventIcon" [innerHTML]="ICONS.locationIcon | safeHtml"></div>
              <span class="ellipsis">{{ eventDetails?.eventLocations[0]?.address || '-' }}</span>
            </li>
          </ul>
        </figcaption>
      </div>
    </div>
  </div>
  <div class="searchResult" *ngIf="pagination.row == 0 && pagination.text != 'Loading...'">
    <div class="searching text-center">
      <h5>{{ pagination.text || '' }}</h5>
    </div>
  </div>
</div>
